module.exports = __webpack_public_path__ + "img/circle_three.58737254.png";